const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://dabac-api.cgis.asia/",
  },
  production: {
      api: "https://dabac-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
